import React, { useState } from "react";
import WithdrawalApply, { FormValues } from "../pages/WithdrawalApply";
import * as aa from "../generated/UserAPIAgent";
import { agent } from "../agent";
import { useHistory } from "react-router";
import { URL_PATHS } from "../routes";
import { smartAlert } from "../lib/confirm-alert";

const WithdrawalApplyContainer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);
    const history = useHistory();

    const onClickConfirmModal = () => {
        setIsShowModal(true);
        return;
    };
    const onClickModalClose = () => {
        setIsShowModal(false);
        return;
    };
    const onSubmitWithdrawalApply = async (data: FormValues) => {
        setIsLoading(true);
        const body: aa.RequestWithdrawalRequestBody = {
            reasons: data.reasons.map((reason) =>
                Number(reason)
            ) as aa.WithdrawalRequestReason[],
            opinion: data.opinion
        };
        try {
            await agent.requestWithdrawal(body);
            setIsLoading(false);
            history.push(URL_PATHS.withdrawalApplyFinish());
        } catch (e) {
            setIsLoading(false);
            console.error(e);
            await smartAlert("退会申請に失敗しました。");
        }
    };

    return (
        <WithdrawalApply
            onClickConfirmModal={onClickConfirmModal}
            onClickModalClose={onClickModalClose}
            onSubmitWithdrawalApply={onSubmitWithdrawalApply}
            isLoading={isLoading}
            isShowModal={isShowModal}
        />
    );
};

export default WithdrawalApplyContainer;
